<template>
  <section class="request-section">
    <div class="white-section container">
      <h1>REQUEST KITS</h1>
      <p>
        Ready to show that sun who's boss? Fill out your kit request below.<br/>
      </p>
      <p>
        Please note, kits are intended for external educational use only and are not to be used for in-office distribution.
      </p>
      <p>Please allow 4–6 weeks for your kits to arrive.</p>
      <p class="errorMsg-text" v-if="errors.length != 0">
        Please check the fields below to correct any errors and submit again. </p>
      <form id="requestKitForm" @submit.prevent="sendFormData()">
        <div class="form-container" v-if="showEducatorKit">
          <div class="he">
            <h2>Educator kit request</h2>
            <p class="mb-1rem">
              Each verified NPI healthcare provider may receive one educator kit as a one-time request.
            </p>
          </div>
          <div class="im">
            <img src="@/assets/images/global/Sun-Heroes-EDUCATOR-Swag-Graphic.jpg" class="responsive"/>
          </div>
          <div class="ff">
            <div class="double-col">
              <p>
                <strong>Where should we ship your educator kit?</strong>
              </p>
            </div>
            <div class="form-field">
              <label><span>*</span>First name</label> <input type="text" v-model="educatorFirstName"
                                                             :class="{ invalid: errors.educatorFirstName }"
                                                             @input="clear_error('educatorFirstName')"/>
              <p class="errorMsg-text" v-if="errors.educatorFirstName">
                First name is required </p>
            </div>
            <div class="form-field">
              <label><span>*</span>Last name</label> <input type="text" v-model="educatorLastName"
                                                            :class="{ invalid: errors.educatorLastName }"
                                                            @input="clear_error('educatorLastName')"/>
              <p class="errorMsg-text" v-if="errors.educatorLastName">
                Last name is required. </p>
            </div>
            <div class="form-field">
              <label><span>*</span>Street address 1</label> <input type="text" v-model="educatorAddressFirst"
                                                                   :class="{ invalid: errors.educatorAddressFirst }"
                                                                   @input="clear_error('educatorAddressFirst')"/>
              <p class="errorMsg-text" v-if="errors.educatorAddressFirst">
                The street address is required. </p>
            </div>
            <div class="form-field">
              <label>Street address 2</label> <input type="text" v-model="educatorAddressSecond"/>
            </div>
            <div class="form-field">
              <label><span>*</span>City</label> <input type="text" v-model="educatorCity"
                                                       :class="{ invalid: errors.educatorCity }"
                                                       @input="clear_error('educatorCity')"/>
              <p class="errorMsg-text" v-if="errors.educatorCity">
                City is required. </p>
            </div>
            <div class="form-field half-col">
              <label><span>*</span>State</label>
              <div class="selectField request">
                <select v-model="educatorState" :class="{ invalid: errors.educatorState }"
                        @input="clear_error('educatorState')">
                  <option value="AL">AL</option>
                  <option value="AK">AK</option>
                  <option value="AR">AR</option>
                  <option value="AZ">AZ</option>
                  <option value="CA">CA</option>
                  <option value="CO">CO</option>
                  <option value="CT">CT</option>
                  <option value="DC">DC</option>
                  <option value="DE">DE</option>
                  <option value="FL">FL</option>
                  <option value="GA">GA</option>
                  <option value="HI">HI</option>
                  <option value="IA">IA</option>
                  <option value="ID">ID</option>
                  <option value="IL">IL</option>
                  <option value="IN">IN</option>
                  <option value="KS">KS</option>
                  <option value="KY">KY</option>
                  <option value="LA">LA</option>
                  <option value="MA">MA</option>
                  <option value="MD">MD</option>
                  <option value="ME">ME</option>
                  <option value="MI">MI</option>
                  <option value="MN">MN</option>
                  <option value="MO">MO</option>
                  <option value="MS">MS</option>
                  <option value="MT">MT</option>
                  <option value="NC">NC</option>
                  <option value="NE">NE</option>
                  <option value="NH">NH</option>
                  <option value="NJ">NJ</option>
                  <option value="NM">NM</option>
                  <option value="NV">NV</option>
                  <option value="NY">NY</option>
                  <option value="ND">ND</option>
                  <option value="OH">OH</option>
                  <option value="OK">OK</option>
                  <option value="OR">OR</option>
                  <option value="PA">PA</option>
                  <option value="RI">RI</option>
                  <option value="SC">SC</option>
                  <option value="SD">SD</option>
                  <option value="TN">TN</option>
                  <option value="TX">TX</option>
                  <option value="UT">UT</option>
                  <option value="VT">VT</option>
                  <option value="VA">VA</option>
                  <option value="WA">WA</option>
                  <option value="WI">WI</option>
                  <option value="WV">WV</option>
                  <option value="WY">WY</option>
                </select>
                <p class="errorMsg-text" v-if="errors.educatorState">
                  State is required. </p>
              </div>
            </div>
            <div class="form-field half-col">
              <label><span>*</span>Zip code</label> <input type="text" v-model="educatorZip" placeholder="00000"
                                                           maxlength="5" :class="{ invalid: errors.educatorZip }"
                                                           @input="clear_error('educatorZip')"/>
              <p class="errorMsg-text" v-if="errors.educatorZip">
                Zip code is required. </p>
            </div>
            <div class="superhero-cta" v-if="!showStudentKit">
             <button :disabled="disableSubmit">Request <i class="fas fa-caret-right"></i></button>
             <div class="superhero-gif">
               <img src="@/assets/images/global/super-hero-4.gif" alt=""/>
             </div>
           </div>
          </div>
        </div>

        <div v-if="showEducatorPlaceholder" class="mb-3">
          <h2>Educator kit request</h2>
          <div>
            <p><strong>Looks like our educator kits are catching more rays than expected!</strong></p>
            <p>We’re temporarily out of stock, but more are on the way. Please check back soon to place your request.</p>
          </div>
        </div>

        <hr/>

        <div class="form-container" v-if="showStudentKit">
          <div class="he header-mobile">
            <h2>
              Student kit request & presentation information
            </h2>
            <p class="sh sub-header-mobile">
              These student kits are designed for educational use in schools, camps, and similar programs. To ensure fair distribution, <strong style="text-decoration: underline">each office may request up to 150 student kits per month</strong>—unless multiple doctors are presenting separately.
            </p>
            <p class="sh sub-header-mobile" :class="{ 'errorMsg-text': Object.keys(errors).length > 0 }">
              You have ordered {{ studentKitsOrdered }} in the past 30 days. See your <router-link class="pa-link" :to="{ name: 'OrderHistory' }">Order History</router-link>.
            </p>
            <p class="sh sub-header-mobile">
              Please <router-link class="pa-link" :to="{ name: 'Contact' }">contact us</router-link>
              to discuss any larger order requests.
            </p>
          </div>
          <div class="im">
            <img src="@/assets/images/global/Sun-Heroes-STUDENT-Swag-Graphic.jpg" class="responsive"/>
          </div>
          <div class="ff">
            <div class="form-field">
              <label><span>*</span>School or program name</label> <input type="text" v-model="studentSchoolProname"
                                                                         :class="{ invalid: errors.studentSchoolProname }"
                                                                         @input="clear_error('studentSchoolProname')"/>
              <p class="errorMsg-text" v-if="errors.studentSchoolProname">
                School or program name is required. </p>
            </div>
            <div class="form-field half-col">
              <label>Presentation date</label> <input type="date" v-model="studentPresentationDate"
                                                      placeholder="MM/DD/YYYY"
                                                      :min="new Date().toISOString().slice(0, 10)"
                                                      :class="{ invalid: errors.studentPresentationDate }"
                                                      @input="clear_error('studentPresentationDate')"/>
              <p class="errorMsg-text" v-if="errors.studentPresentationDate">
                Invalid date format. </p>
            </div>
            <div class="form-field half-col">
              <label><span>*</span>School&nbsp;zip&nbsp;code</label> <input type="text" v-model="studentZip"
                                                                            placeholder="00000" maxlength="5"
                                                                            :class="{ invalid: errors.studentZip }"
                                                                            @input="clear_error('studentZip')"/>
              <p class="errorMsg-text" v-if="errors.studentZip">
                School zip code is required. </p>
            </div>
            <div class="form-field">
              <label><span>*</span>Number of kits needed</label> <div class="selectField request" style="width: 90%">
                <select
                  v-model="studentNeededKitNum"
                  :class="{ invalid: errors.studentNeededKitNum }"
                  @input="clear_error('studentNeededKitNum')"
                  @blur="checkKitNum">
                  <option value="30">30</option>
                  <option value="60">60</option>
                  <option value="90">90</option>
                  <option value="120">120</option>
                  <option value="150">150</option>
                </select>
              </div>
              <p class="errorMsg-text" v-if="errors.studentNeededKitNum">
                {{ errors.studentNeededKitNum[0].replace(/[\[\]"]/g, '')  }}
              </p>
            </div>
            <div class="form-field orange-callout">
              <img src="@/assets/images/request-kits-four-six-weeks.png" alt=""/> <span>Please allow 4–6 weeks for your kits to arrive.</span>
            </div>
            <div class="form-field">
              <label><span>*</span>Grade level/age</label> <input type="text" v-model="studentGradeLevel"
                                                                  :class="{ invalid: errors.studentGradeLevel }"
                                                                  @input="clear_error('studentGradeLevel')"/>
              <p class="errorMsg-text" v-if="errors.studentGradeLevel">
                Grade level/age is required. </p>
            </div>
            <div class="double-col">
              <p class="sub-header-mobile">
                <strong>Where should we ship your<br class="header-br"/> student kits?</strong>
              </p>
            </div>
            <div class="form-field">
              <label><span>*</span>First name</label> <input type="text" v-model="studentFirstName"
                                                             :class="{ invalid: errors.studentFirstName }"
                                                             @input="clear_error('studentFirstName')"/>
              <p class="errorMsg-text" v-if="errors.studentFirstName">
                First name is required. </p>
            </div>
            <div class="form-field">
              <label><span>*</span>Last name</label> <input type="text" v-model="studentLastName"
                                                            :class="{ invalid: errors.studentLastName }"
                                                            @input="clear_error('studentLastName')"/>
              <p class="errorMsg-text" v-if="errors.studentLastName">
                Last name is required. </p>
            </div>
            <div class="form-field">
              <label><span>*</span>Street address 1</label> <input type="text" v-model="studentAddressFirst"
                                                                   :class="{ invalid: errors.studentAddressFirst }"
                                                                   @input="clear_error('studentAddressFirst')"/>
              <p class="errorMsg-text" v-if="errors.studentAddressFirst">
                Street address is required. </p>
            </div>
            <div class="form-field">
              <label>Street address 2</label> <input type="text" v-model="studentAddressSecond"/>
            </div>
            <div class="form-field">
              <label><span>*</span>City</label> <input type="text" v-model="studentCity"
                                                       :class="{ invalid: errors.studentCity }"
                                                       @input="clear_error('studentCity')"/>
              <p class="errorMsg-text" v-if="errors.studentCity">
                City is required. </p>
            </div>
            <div class="form-field half-col">
              <label><span>*</span>State</label>
              <div class="selectField request">
                <select v-model="studentState" :class="{ invalid: errors.studentState }"
                        @input="clear_error('studentState')">
                  <option value="AL">AL</option>
                  <option value="AK">AK</option>
                  <option value="AR">AR</option>
                  <option value="AZ">AZ</option>
                  <option value="CA">CA</option>
                  <option value="CO">CO</option>
                  <option value="CT">CT</option>
                  <option value="DC">DC</option>
                  <option value="DE">DE</option>
                  <option value="FL">FL</option>
                  <option value="GA">GA</option>
                  <option value="HI">HI</option>
                  <option value="IA">IA</option>
                  <option value="ID">ID</option>
                  <option value="IL">IL</option>
                  <option value="IN">IN</option>
                  <option value="KS">KS</option>
                  <option value="KY">KY</option>
                  <option value="LA">LA</option>
                  <option value="MA">MA</option>
                  <option value="MD">MD</option>
                  <option value="ME">ME</option>
                  <option value="MI">MI</option>
                  <option value="MN">MN</option>
                  <option value="MO">MO</option>
                  <option value="MS">MS</option>
                  <option value="MT">MT</option>
                  <option value="NC">NC</option>
                  <option value="NE">NE</option>
                  <option value="NH">NH</option>
                  <option value="NJ">NJ</option>
                  <option value="NM">NM</option>
                  <option value="NV">NV</option>
                  <option value="NY">NY</option>
                  <option value="ND">ND</option>
                  <option value="OH">OH</option>
                  <option value="OK">OK</option>
                  <option value="OR">OR</option>
                  <option value="PA">PA</option>
                  <option value="RI">RI</option>
                  <option value="SC">SC</option>
                  <option value="SD">SD</option>
                  <option value="TN">TN</option>
                  <option value="TX">TX</option>
                  <option value="UT">UT</option>
                  <option value="VT">VT</option>
                  <option value="VA">VA</option>
                  <option value="WA">WA</option>
                  <option value="WI">WI</option>
                  <option value="WV">WV</option>
                  <option value="WY">WY</option>
                </select>
                <p class="errorMsg-text" v-if="errors.studentState">
                  State is required. </p>
              </div>
            </div>
            <div class="form-field half-col">
              <label><span>*</span>Zip code</label> <input type="text" v-model="studentShipZip" placeholder="00000"
                                                           maxlength="5" :class="{ invalid: errors.studentShipZip }"
                                                           @input="clear_error('studentShipZip')"/>
              <p class="errorMsg-text" v-if="errors.studentShipZip">
                Zip code is required. </p>
            </div>
            <div class="gray-callout" v-if="showRefillKit">
              <img src="@/assets/images/request-kits-sample-cards.png" alt=""/> <label class="checkbox">
                <span class="checkbox-input">
                  <input type="checkbox" v-model="ranOutOfCards"/>
                  <span class="checkbox-control">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                      <path fill="none" stroke="currentColor" stroke-width="3" d="M1.73 12.91l6.37 6.37L22.79 4.59"/>
                    </svg>
                  </span>
                </span> I've run out of cards and need more. </label>
            </div>
            <div class="submit-col" v-show="ranOutOfCards && showRefillKit">
              <p>
                <strong>How many would you like to add<br class="header-br"/> to this order?</strong>
              </p>
            </div>
            <div class="form-field half-col" v-show="ranOutOfCards">
              <label><span>*</span>Select quantity</label>
              <div class="selectField request">
                <select v-model="cardsQuantity" :class="{ invalid: errors.cardsQuantity }"
                        @input="clear_error('cardsQuantity')">
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="150">150</option>
                </select>
                <p class="errorMsg-text" v-if="errors.cardsQuantity">
                  Please specify the number of cards, and must be 150 or less in the past 30 days.</p>
              </div>
            </div>
            <div></div>
            <div class="double-col" v-show="ranOutOfCards && showRefillKit">
              <label class="checkbox">
                <span class="checkbox-input">
                  <input type="checkbox" v-model="sameShippingAddress"/>
                  <span class="checkbox-control">
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                      <path fill="none" stroke="currentColor" stroke-width="3" d="M1.73 12.91l6.37 6.37L22.79 4.59"/>
                    </svg>
                  </span>
                </span> <strong class="checkbox-text">Ship to the same address as<br class="header-br"/> the student
                kits</strong> </label>
              <p v-show="!sameShippingAddress">
                <strong>Where should we ship your cards?</strong>
              </p>
            </div>
            <div class="form-field" v-show="!sameShippingAddress">
              <label><span>*</span>First name</label> <input type="text" v-model="cardsFirstName"
                                                             :class="{ invalid: errors.cardsFirstName }"
                                                             @input="clear_error('cardsFirstName')"/>
              <p class="errorMsg-text" v-if="errors.cardsFirstName">
                First name is required. </p>
            </div>
            <div class="form-field" v-show="!sameShippingAddress">
              <label><span>*</span>Last name</label> <input type="text" v-model="cardsLastName"
                                                            :class="{ invalid: errors.cardsLastName }"
                                                            @input="clear_error('cardsLastName')"/>
              <p class="errorMsg-text" v-if="errors.cardsLastName">
                Last name is required. </p>
            </div>
            <div class="form-field" v-show="!sameShippingAddress">
              <label><span>*</span>Street address 1</label> <input type="text" v-model="cardsAddressFirst"
                                                                   :class="{ invalid: errors.cardsAddressFirst }"
                                                                   @input="clear_error('cardsAddressFirst')"/>
              <p class="errorMsg-text" v-if="errors.cardsAddressFirst">
                Street address is required. </p>
            </div>
            <div class="form-field" v-show="!sameShippingAddress">
              <label>Street address 2</label> <input type="text" v-model="cardsAddressSecond"/>
            </div>
            <div class="form-field" v-show="!sameShippingAddress">
              <label><span>*</span>City</label> <input type="text" v-model="cardsCity"
                                                       :class="{ invalid: errors.cardsCity }"
                                                       @input="clear_error('cardsCity')"/>
              <p class="errorMsg-text" v-if="errors.cardsCity">
                City is required. </p>
            </div>
            <div class="form-field half-col" v-show="!sameShippingAddress">
              <label><span>*</span>State</label>
              <div class="selectField request">
                <select v-model="cardsState" :class="{ invalid: errors.cardsState }" @input="clear_error('cardsState')">
                  <option value="AL">AL</option>
                  <option value="AK">AK</option>
                  <option value="AR">AR</option>
                  <option value="AZ">AZ</option>
                  <option value="CA">CA</option>
                  <option value="CO">CO</option>
                  <option value="CT">CT</option>
                  <option value="DC">DC</option>
                  <option value="DE">DE</option>
                  <option value="FL">FL</option>
                  <option value="GA">GA</option>
                  <option value="HI">HI</option>
                  <option value="IA">IA</option>
                  <option value="ID">ID</option>
                  <option value="IL">IL</option>
                  <option value="IN">IN</option>
                  <option value="KS">KS</option>
                  <option value="KY">KY</option>
                  <option value="LA">LA</option>
                  <option value="MA">MA</option>
                  <option value="MD">MD</option>
                  <option value="ME">ME</option>
                  <option value="MI">MI</option>
                  <option value="MN">MN</option>
                  <option value="MO">MO</option>
                  <option value="MS">MS</option>
                  <option value="MT">MT</option>
                  <option value="NC">NC</option>
                  <option value="NE">NE</option>
                  <option value="NH">NH</option>
                  <option value="NJ">NJ</option>
                  <option value="NM">NM</option>
                  <option value="NV">NV</option>
                  <option value="NY">NY</option>
                  <option value="ND">ND</option>
                  <option value="OH">OH</option>
                  <option value="OK">OK</option>
                  <option value="OR">OR</option>
                  <option value="PA">PA</option>
                  <option value="RI">RI</option>
                  <option value="SC">SC</option>
                  <option value="SD">SD</option>
                  <option value="TN">TN</option>
                  <option value="TX">TX</option>
                  <option value="UT">UT</option>
                  <option value="VT">VT</option>
                  <option value="VA">VA</option>
                  <option value="WA">WA</option>
                  <option value="WI">WI</option>
                  <option value="WV">WV</option>
                  <option value="WY">WY</option>
                </select>
                <p class="errorMsg-text" v-if="errors.cardState">
                  State is required. </p>
              </div>
            </div>
            <div class="form-field half-col" v-show="!sameShippingAddress">
              <label><span>*</span>Zip code</label> <input type="text" v-model="cardsZip" placeholder="00000"
                                                           maxlength="5" :class="{ invalid: errors.cardsZip }"
                                                           @input="clear_error('cardsZip')"/>
              <p class="errorMsg-text" v-if="errors.cardsZip">
                Zip code is required. </p>
            </div>
            <div class="form-field error-row double-col" v-if="errors.length != 0">
              <p class="errorMsg-text">
                Please check the fields above to correct any errors and submit again. </p>
            </div>
            <div class="submit-col">
              <p class="footnote">
                Fields marked with an asterisk are required. </p>
              <div class="loader-container">
                <img v-show="showLoader" src="@/assets/images/global/loader.gif" alt=""/>
              </div>
            </div>
           <div class="superhero-cta">
             <button :disabled="disableSubmit">Request <i class="fas fa-caret-right"></i></button>
             <div class="superhero-gif">
               <img src="@/assets/images/global/super-hero-4.gif" alt=""/>
             </div>
           </div>
          </div>
        </div>

         <div v-if="showStudentPlaceholder" class="mb-3">
          <h2>Student kit request & presentation information</h2>
          <div>
            <p><strong>Turns out saving the day is in high demand—our student kits are out of stock!</strong></p>
            <p>We’re gearing up for a fresh round, so please check back soon to place your request.</p>
          </div>
        </div>

      </form>
    </div>
  </section>
</template>
<script>
export default {
  data () {
    return {
      showEducatorKit: false,
      showStudentKit: true,
      showRefillKit: false,
      showEducatorLoader: false,
      showRefillLoader: false,
      disableSubmit: false,

      showStudentPlaceholder: false,
      showEducatorPlaceholder: false,

      educatorFirstName: this.$store.state.firstName,
      educatorLastName: this.$store.state.lastName,
      educatorAddressFirst: '',
      educatorAddressSecond: '',
      educatorCity: '',
      educatorState: '',
      educatorZip: '',

      studentSchoolProname: '',
      studentPresentationDate: '',
      studentZip: '',
      studentNeededKitNum: '',
      studentGradeLevel: '',
      studentFirstName: '',
      studentLastName: '',
      studentAddressFirst: '',
      studentAddressSecond: '',
      studentCity: '',
      studentState: '',
      studentShipZip: '',

      ranOutOfCards: false,
      sameShippingAddress: true,
      showLoader: false,
      cardsQuantity: '',
      cardsFirstName: '',
      cardsLastName: '',
      cardsAddressFirst: '',
      cardsAddressSecond: '',
      cardsCity: '',
      cardsState: '',
      cardsZip: '',

      studentKitsOrdered: '&nbsp;&nbsp;',

      errors: [],
      options: {}
    }
  },
  created () {
    this.getInitial()
  },
  watch: {
    studentNeededKitNum (newVal) {
      const maxKits = 150 - this.studentKitsOrdered
      if (newVal > maxKits) {
        this.errors.studentNeededKitNum = [`"Number of kits must be ${maxKits} or less in the past 30 days."`]
      } else {
        this.errors.studentNeededKitNum = ''
      }
    }
  },
  methods: {
    checkKitNum () {
      if (this.errors.studentNeededKitNum) {
        alert(this.errors.studentNeededKitNum[0])
      }
    },
    async getInitial () {
      const _this = this

      _this.axios.get(_this.$apiUrl + 'v1/order/totalStudentKits').then(function (response) {
        if (response.data.errors.length === 0) {
          _this.studentKitsOrdered = response.data.studentKitsOrdered
        }
      }).catch(function () { })

      _this.axios.get(_this.$apiUrl + 'v1/account').then(function (response) {
        if (response.data.errors.length === 0) {
          const d = response.data.user
          _this.educatorFirstName = d.first_name
          _this.educatorLastName = d.last_name
          _this.educatorZip = d.practice_zip_code

          _this.studentFirstName = d.first_name
          _this.studentLastName = d.last_name
          _this.studentShipZip = d.practice_zip_code

          _this.cardsFirstName = d.first_name
          _this.cardsLastName = d.last_name
          _this.cardsZip = d.practice_zip_code
        }
      }).catch(function () {})

      const [hasOrdered, options] = await Promise.all([
        this.getHasOrderedKit(),
        this.getOptions()
      ])

      if (options.data.data && hasOrdered.data.errors.length === 0) {
        // only display placeholder when educator or student toggle disable from admin
        _this.showEducatorPlaceholder = options.data.data.disable_educator_kit?.toString() === '1'
        _this.showStudentPlaceholder = options.data.data.disable_student_kit?.toString() === '1'

        // educator kit visibility
        if (options.data.data.disable_educator_kit?.toString() === '1') {
          _this.showEducatorKit = false
        } else {
          if (parseInt(options.data.data.qty_educator_kit) < parseInt(options.data.data.warning_educator_kit)) {
            this.showEducatorKit = false
            this.showEducatorPlaceholder = true
          } else if (hasOrdered.data.has_ordered) {
            _this.showEducatorKit = false
          } else {
            _this.showEducatorKit = options.data.data.disable_educator_kit?.toString() === '0'
          }
          if (parseInt(options.data.data.qty_educator_kit) < 1 || !options.data.data.qty_educator_kit) {
            _this.showEducatorKit = false
            this.showEducatorPlaceholder = true
          }
        }

        // student kit visibility
        if (options.data.data.disable_student_kit?.toString() === '1') {
          _this.showStudentKit = false
        } else {
          if (parseInt(options.data.data.qty_student_kit) < parseInt(options.data.data.warning_student_kit)) {
            _this.showStudentKit = false
            _this.showStudentPlaceholder = true
          } else if (hasOrdered.data.has_ordered) {
            _this.showStudentKit = true
          } else {
            _this.showStudentKit = options.data.data.disable_student_kit?.toString() === '0'
          }
          if (parseInt(options.data.data.qty_student_kit) < 30 || !options.data.data.qty_student_kit) {
            _this.showStudentKit = false
            _this.showStudentPlaceholder = true
          }
        }

        // refill kit visibility
        if (parseInt(options.data.data.qty_refill_kit) < parseInt(options.data.data.warning_refill_kit)) {
          this.showRefillKit = false
        } else { _this.showRefillKit = hasOrdered.data.has_ordered }
      }
    },
    getOptions () {
      return this.axios.get(this.$apiUrl + 'v1/admin/options/get')
    },
    getHasOrderedKit () {
      return this.axios.post(this.$apiUrl + 'v1/wasStarterKitOrdered')
    },
    clear_error (field) {
      if (typeof this.errors[field] !== 'undefined') {
        delete this.errors[field]
      }
    },
    sendFormData () {
      const _this = this
      _this.showLoader = true
      _this.disableSubmit = true
      var payload = {
        educatorFirstName: _this.educatorFirstName,
        educatorLastName: _this.educatorLastName,
        educatorAddressFirst: _this.educatorAddressFirst,
        educatorAddressSecond: _this.educatorAddressSecond,
        educatorCity: _this.educatorCity,
        educatorState: _this.educatorState,
        educatorZip: _this.educatorZip,
        studentSchoolProname: _this.studentSchoolProname,
        studentPresentationDate: _this.studentPresentationDate,
        studentZip: _this.studentZip,
        studentNeededKitNum: _this.studentNeededKitNum,
        studentGradeLevel: _this.studentGradeLevel,
        studentFirstName: _this.studentFirstName,
        studentLastName: _this.studentLastName,
        studentAddressFirst: _this.studentAddressFirst,
        studentAddressSecond: _this.studentAddressSecond,
        studentCity: _this.studentCity,
        studentState: _this.studentState,
        studentShipZip: _this.studentShipZip,

        ranOutOfCards: _this.ranOutOfCards,
        cardsQuantity: _this.cardsQuantity,
        sameShippingAddress: _this.sameShippingAddress,
        cardsFirstName: _this.cardsFirstName,
        cardsLastName: _this.cardsLastName,
        cardsAddressFirst: _this.cardsAddressFirst,
        cardsAddressSecond: _this.cardsAddressSecond,
        cardsCity: _this.cardsCity,
        cardsState: _this.cardsState,
        cardsZip: _this.cardsZip
      }
      if (this.showEducatorKit) { payload = { ...payload, educatorKitQuantity: 1 } }

      _this.axios.post(_this.$apiUrl + 'v1/order', payload).then(function (response) {
        _this.disableSubmit = false
        if (response.data.errors.length === 0) {
          _this.$router.push({ name: 'RequestKitsThankYou' }).catch(() => {})
          _this.showLoader = false
        } else {
          _this.errors = response.data.errors
          _this.showLoader = false
          // TODO: Add error output above
        }
        _this.showResponse = true
      }).catch(function (error) {
        _this.disableSubmit = false
        _this.errors = error.response.data.errors
        _this.showLoader = false
        setTimeout(() => {
          document.querySelector('input.invalid,select.invalid').focus()
        }, 200)
      })
    }
  }
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

section {
  overflow: hidden;
}

section.request-section {
  .container {
    h1 {
      margin-top: 1.1em;
      font-size: 45px;
      text-align: center;
      @media screen and (min-width: ~"@{mq-md-bp}em") {
        font-size: 60px;
        text-align: left;
      }
    }

    h2 {
      font-size: 22px;
      margin-top: 22px;
    }

    p {
      font-size: 18px;
    }

    .subhead-mt {
      margin-top: 22px;
    }

    .mb-1rem {
      margin-bottom: 1rem;
      line-height: 1.5;
    }

    .mb-4rem {
      margin-bottom: 4rem;
    }

    .footnote {
      font-size: 12px;
      color: #000;
      margin-bottom: 20px;
    }

    .form-container {
      display: grid;
      grid-template-columns: 1 1fr;
      grid-template-rows: auto;
      grid-template-areas:
        "he"
        "im"
        "ff";
      grid-gap: 30px;
    }
  }

  .pa-link {
    color: @color-dk-orange;
    text-decoration: underline;
    cursor: pointer;
  }

  .he {
    grid-area: he;
  }

  .im {
    grid-area: im;

    img {
      max-width: 100%;
      height: auto;
    }
  }

  .ff {
    grid-area: ff;
    display: grid;
    grid-gap: 30px;
    grid-template-columns: 1fr 1fr;
    margin-bottom: 0px;
    @media screen and (min-width: ~"@{mq-md-bp}em") {
      margin-bottom: 30px;
    }

    .double-col {
      grid-column: span 3;
    }

    .submit-col {
      grid-column: span 4;
    }

    .gray-callout {
      grid-column: span 4;
      background-color: @color-lt-gray;
      padding: 20px 25px;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 84%;
      @media screen and (min-width: ~"@{mq-md-bp}em") {
        width: auto;
      }

      img {
        max-width: 68px;
        margin-right: 10px;
        @media screen and (min-width: ~"@{mq-md-bp}em") {
          margin-right: 0;
        }
        height: auto;
      }
    }

    .form-field {
      grid-column: span 4;
      @media screen and (min-width: ~"@{mq-md-bp}em") {
        grid-column: span 2;
      }

      textarea,
      select,
      input[type="text"],
      input[type="email"],
      input[type="name"],
      input[type="number"],
      input[type="date"],
      input[type="tel"] {
        margin-bottom: 0;
        margin-right: auto;

        &.invalid + .errorMsg-text {
          font-size: 1.5rem;
        }
      }

      &.half-col {
        grid-column: span 1;

        input {
          width: 89% !important;
          @media screen and (min-width: ~"@{mq-md-bp}em") {
            width: auto;
          }
        }

        // @media screen and (min-width: ~"@{mq-md-bp}em") {
        //   grid-column: span 1;
        // }
      }

      &.orange-callout {
        background-color: @color-yellow;
        flex-direction: row;
        justify-content: space-evenly;
        align-items: center;
        grid-row: 5;
        padding: 10px 0px;
        width: 84%;
        // @media screen and (min-width: ~"@{mq-xs-bp}") {
        //   width: 100%;
        // }
        @media screen and (min-width: ~"@{mq-md-bp}em") {
          width: auto;
        }

        img {
          max-width: 47px;
          height: auto;
        }

        span {
          color: @color-txt-blue;
          font-size: 1.5rem;
          font-weight: 600;
          width: 70%;
        }
      }
    }
  }
}

@media screen and (min-width: ~"@{mq-md-bp}em") {
  section.request-section {
    .container {
      .form-container {
        grid-template-columns: repeat(3, 1fr);
        grid-template-rows: auto;
        grid-template-areas:
          "he he he"
          "im ff ff";
      }
    }

    .ff {
      grid-template-columns: repeat(4, 1fr);

      .double-col {
        grid-column: span 4;
      }

      .submit-col {
        grid-column: span 4;
      }

      .form-field {
        &.orange-callout {
          grid-row: auto;
        }
      }
    }
  }
}

.superhero-image {
  width: 31rem;
  position: absolute;
  left: 30rem;
  top: 1rem;
  pointer-events: none;
}

.contact-header {
  display: flex;
  padding-top: 10rem;
  flex-flow: row wrap;

  h1 {
    font-size: 60px;
  }

  .link-color {
    color: @color-dk-orange !important;
    text-decoration: underline;
    cursor: pointer;
  }

  p {
    margin-top: 8rem;
  }
}

form {
  p {
    margin-top: 0 !important;

    &.sh {
      margin-top: 10px !important;
      margin-bottom: 10px;
      font-size: 18px;
    }
  }

  button {
    background-color: @color-orange;
    font-weight: 700;
    font-size: .clampedWrem(3, @md-bp, @large-bp) [ @result];
    text-transform: uppercase;
    border: none;
    padding: 1rem 1rem 1rem 1rem;

    &:disabled {
      opacity: 0.6;
    }
  }
}

.form-row-1 {
  display: flex;
  padding-top: 4rem;
}

.form-row-2 {
  textarea {
    width: 72.3rem !important;
    height: 18rem !important;
  }
}

.superhero-cta {
  // display: flex;
  // flex-direction: column;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    margin-left: 38%;
    margin-right: auto;
    margin-top: 60px;
    // margin-bottom: 30px;
  }

  button {
    background-color: @color-orange;
    cursor: pointer;
    border: none;
    font-weight: 700;
    font-family: @open-sans-font;
    text-transform: uppercase;
    color: @color-txt-blue;
    width: 14rem;
    height: 4.5rem;
    font-size: 19px;
    text-align: left;
    padding-left: 1.5rem;
    padding-right: 1.5rem;

    .fa-caret-right {
      margin-left: 10px;
    }
  }

  .superhero-gif {
    position: relative;
    left: 15rem;
    top: -62px;
    width: 72px;

    img {
      width: 9rem;
    }
  }
}

.loader-container {
  width: 32px;
  height: 32px;
}

input {
  width: 89% !important;
  @media (max-width: 767px) {
    width: 100% !important;
  }
  @media (max-width: 400px) {
    width: 85% !important;
  }
  @media screen and (min-width: ~"@{mq-md-bp}em") {
    width: auto;
  }
}

.header-mobile {
  width: 76%;
  @media screen and (min-width: 600px) {
    width: auto;
  }
}

.sub-header-mobile {
  // width: 120%;
  // @media screen and (min-width: 600px) {
  //   width: auto;
  // }
}

.header-br {
  display: block;
  @media screen and (min-width: 600px) {
    display: none;
  }
}
.mb-3 {
  margin-bottom: 3rem;
}
</style>
